import { FieldParams } from "@/components/package-components/constants";
import { ComponentsBaseProps } from "../../types";

export enum ActionType {
  sendEmail = "sendEmail",
  sendWhatsApp = "sendWhatsApp",
  sendSMS = "sendSMS",
}

export enum FieldType {
  text = "text",
}

export enum FieldName {
  name = "name",
  email = "email",
  cellphone = "cellphone",
  message = "message",
}

export interface FormContact1Props extends ComponentsBaseProps {
  actionType: ActionType[];
  button: ButtonProps;
  n8nWorkflowId?: FieldParams;
  image?: FieldParams;
  formName?: FieldParams;
  description?: FieldParams;
  variant: {
    currentVariantId?: string;
    variants: FormVariationProps[];
  };
}

export interface FormVariationProps extends FormVariantBaseProps {
  //@ts-ignore
  fields: {
    value: FieldProps[];
  };
}

export interface FormVariantBaseProps {
  [key: symbol | string | "fields"]: FieldProps;
}

export interface FieldProps {
  label: string;
  placeholder: string;
  type: string;
  name: FieldName;
  required: boolean;
  regex: string | null;
  minLength: number | null;
  maxLength: number | null;
}

export interface ButtonProps {
  icon: boolean | null;
}
